import React, { Component } from 'react';
import {withRouter} from "react-router-dom";
import { connect } from 'react-redux';
import Navigation from './components/Navigation';
import sync from 'css-animation-sync';

import createjs from "preload-js";

import ComponentRenderer from './components/ComponentRenderer';
import IntroModal from './components/IntroModal';


class Scene extends Component {

  constructor(props){
    super(props);

    this.state = {
      backgroundImages: undefined,
      introModalOpen: this.props.scene.current && typeof this.props.scene.current.introTitle !== "undefined"
    }

    this.closeIntroModal = this.closeIntroModal.bind(this);
  }

  callback = (data) => {
  }

  componentDidMount(){
    const { backgroundImages } =  this.state;

    var queue = new createjs.LoadQueue(true);
    queue.on("complete", handleComplete, this);
    let fullPaths = backgroundImages.map((image,index)=>
      (this.getBackgroundImagePath(image))
    );
    queue.loadManifest(fullPaths);

    function handleComplete() {
      this.setState({
        loaded: true
      })
    }

    this.setState({
      loaded: true
    });

    sync('hotspot-outer');
    sync('hotspot-inner');
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({introModalOpen: this.props.scene.current && typeof this.props.scene.current.introTitle !== "undefined"});
    }
  }

  static getDerivedStateFromProps(props, state){
    let { scene } = props;

    let foundBackgroundImages = [];
    if(scene.current && scene.current.backgroundImage) {
      foundBackgroundImages.push(scene.current.backgroundImage);
    }

    return {
      ...state,
      backgroundImages: foundBackgroundImages,
      loaded: state.loaded
    }
  }

  getBackgroundImagePath(filename) {
    return `${window.public_url}/images/scenes/background-images/${filename}`
  }

  closeIntroModal() {
    this.setState({introModalOpen: false}, function() {
      window.setTimeout(function() {

        var event = undefined;

        if(typeof(Event) === 'function') {
          event = new Event('resize');
        }else{
          event = document.createEvent('Event');
          event.initEvent('resize', true, true);
        }
        window.dispatchEvent(event);
      }, 1);
    });
  }

  render() {

    let { loaded } = this.state;
    let { scene, menu, orientation, location } = this.props;

    return (
      <div>
        <div id="content">

          {!loaded ? <div>Loading...</div> : null}

          {loaded && scene.current ? (
            <div className={`scene ${menu.open ? 'menu-open' : ''}`}>
              <img className="img-fluid" alt="background" src={this.getBackgroundImagePath(scene.current.backgroundImage)}/>
              {scene.current.components ?
                (
                  <ComponentRenderer components={scene.current.components}/>
                ) : null
              }
              <IntroModal {...scene.current} location={location} isOpen={this.state.introModalOpen && !orientation.isOpen && location.pathname.indexOf("/unlock") < 0} closeModal={this.closeIntroModal} />
            </div>
          ) : null}
        </div>
        <Navigation />
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    scene: state.scene,
    navigation: state.navigation,
    menu: state.menu,
    orientation: state.orientation
  }
}


export default connect(mapStateToProps)(withRouter(Scene));



// WEBPACK FOOTER //
// ./src/Scene.jsx